import { Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-crud',
  templateUrl: './crud.component.html',
  styleUrls: ['./crud.component.css']
})
export class InAPPCrudComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }


  // on submit data

  onSubmit()
  {
    // console.log("on submit data",this.inAppBanner.value);
    
  }

}
